import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/guide-guest-list-etiquette";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/guides/wedding-guest-list-etiquette")({
  head: SEO["/guides/wedding-guest-list-etiquette"],
  component: () => <ContentPage path="/guides/wedding-guest-list-etiquette" body={body} />,
});
